import React from 'react';
import { useNavigate } from 'react-router-dom';


const Audiences = () => {

  const navigate = useNavigate();
  

  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light p-3 rounded-3 d-flex align-items-center gap-3 flex-wrap'>
          <h4 className='mb-0'>Audience</h4>

          <select className="form-select w-auto me-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>

          <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
            <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
            <span>Refresh</span>
          </button>

          <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
            <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
            <span>Share</span>
          </button>

          <button type="button" className='btn btn-primary d-flex align-items-center gap-1 shadow-sm'>
            <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
            <span>Export</span>
          </button>

          <button type="button" className='btn btn-white shadow-sm d-flex align-items-center justify-content-center'><img src="/images/icons/three-dot-black.svg" style={{ height: '20px' }} alt="three-dot-black" /></button>
        </div>

        <div className='bg-light px-3 py-2 rounded-4 my-3 d-flex align-items-center justify-content-between gap-3'>
          <div>
            <h5 className='mb-0'>Create Audience</h5>
            <small>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi, inventore!</small>
          </div>

          <button type="button" className='btn btn-primary d-flex align-items-center gap-1 shadow-sm' onClick={() => navigate(`/create-audience`)}>
            <img src="/images/icons/add-white.svg" style={{ height: '20px' }} alt="dashboard" />
            <span>Create Audience</span>
          </button>
        </div>

        {/* Main */}
        <div className='bg-light p-3 rounded-3'>
          {/* Buttons */}
          <div className='d-flex align-items-center gap-3 flex-wrap mb-5'>
            <button type="button" className='btn btn-primary d-flex align-items-center gap-1 shadow-sm' onClick={() => navigate(`/create-audience`)}>
              <img src="/images/icons/add-white.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Create Audience</span>
            </button>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Copy Audience</span>
            </button>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Edit</span>
            </button>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm me-auto'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Delete</span>
            </button>

            <select className="form-select w-auto">
              <option selected>Customize Columns</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>

            <select className="form-select w-auto">
              <option selected>Breakdown</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Export</span>
            </button>
          </div>

          {/* Table */}
          <div className='overflow-x-scroll scrollbar-hidden'>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" />
                    </div>
                  </th>

                  <th scope="col">Audience Name</th>
                  <th scope="col">Audience Name</th>
                  <th scope="col">Audience Name</th>
                  <th scope="col">Audience Name</th>
                  <th scope="col">Audience Name</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" defaultChecked />
                    </div>
                  </td>

                  <td>First Audience</td>
                  <td>First Audience</td>
                  <td>First Audience</td>
                  <td>First Audience</td>
                  <td>First Audience</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section> 
    </>
  )
}

export default Audiences
